import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForYouTube Derives the specs needed to display an YouTube Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForYouTube(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for YouTube
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '100%', height: '100%' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard YouTube Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.YouTube.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.YouTube, url: matchEmbedUrl.groups.embedUrl, width: '100%', height: '350px' };
  } 

  return displaySpecs;
}
